<template>
  <div>
    <title-edit header="Landing Page" />
    <line-hr />
    <br>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Active" v-model="form.is_active"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title" @update="updateTitle"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Start date* :</label>
      </v-col>
      <v-col cols="12" sm="3"  xs="12">
        <date-picker :model="form.start_date" @update="updateStartDate"/>
      </v-col>
      <v-col cols="12" sm="2"  class="label">
        <label>End date* :</label>
      </v-col>
      <v-col cols="12" sm="3"  xs="12">
        <date-picker :model="form.end_date" @update="updateEndDate"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Button color :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <a @click="showModalButtonColor">
          <v-icon :color="form.button_color" style="font-size: 50px">
            fas fa-square
            <span>click select color</span>
          </v-icon>
        </a>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Font color :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <a @click="showModalFontColor">
          <v-icon :color="form.font_color" style="font-size: 50px">
            fas fa-square
            <span>click select color</span>
          </v-icon>
        </a>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Background :</label>
      </v-col>
      <v-col cols="12" sm="8">
        <v-radio-group v-model="form.background_type" row>
          <v-col cols="3">
            <v-radio label="Color" value="1"></v-radio>
          </v-col>
          <v-col cols="3">
            <v-radio label="Image" value="2"></v-radio>
          </v-col>
        </v-radio-group>
      </v-col>
    </div>
    <div class="row" style="margin-top: -40px">
      <v-col cols="12" sm="3"  class="label">
      </v-col>
      <v-col cols="2">
        <div>Background color</div>
        <a @click="showModalBackgroundColor">
          <v-icon :color="form.background_color" style="font-size: 50px">
            fas fa-square
            <span>click select color</span>
          </v-icon>
        </a>
      </v-col>
      <v-col cols="4">
        <div class="row">
          Background image
          <div style="color: #2E8037; font-size: 12px">*รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px</div>
          <input-image-upload id="image_background" :model="form.background_image_show"
                              width="350px" height="200px"
                              @update="updateBackgroundImage"/>
        </div>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Cover image desktop* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="7" >
        <input-image-upload id="cover_desktop"
                            @update="updateDesktopImage"
                            :model="form.cover_image_desktop_show"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Cover image mobile* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="8">
        <input-image-upload id="cover_mobile" width="300px" height="200px"
                            @update="updateMobileImage"
                            :model="form.cover_image_mobile_show"/>
      </v-col>
    </div>
    <br>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteLandingPage"/>
      <preview-button />
      <save-button @click.native="saveLandingPage"/>
    </div>
    <v-dialog
      ref="dialog"
      v-model="button_color"
      persistent
      width="290px">
      <div style="background-color: #1d2024">
        <select-color @update="updateButtonColor"/>
      </div>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="font_color"
      persistent
      width="290px">
      <div style="background-color: #1d2024">
        <select-color @update="updateFontColor"/>
      </div>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="background_color"
      persistent
      width="290px">
      <div style="background-color: #1d2024">
        <select-color @update="updateBackgroundColor"/>
      </div>
    </v-dialog>
<!--    <pre>{{form}}</pre>-->
  </div>
</template>

<script>
  import TitleEdit from "../../components/TitleHeader/TitleEdit";
  import LineHr from "../../components/Icon/line-hr";
  import SelectOption from "../../components/Input/selectOption";
  import InputTextField from "../../components/Input/InputTextField";
  import DeleteButton from "../../components/Button/DeleteButton";
  import PreviewButton from "../../components/Button/PreviewButton";
  import SaveButton from "../../components/Button/SaveButton";
  import {mapState} from "vuex";
  import DatePicker from "../../components/Input/DatePicker";
  import SelectColor from "../../components/Input/SelectColor";
  import InputImageUpload from "../../components/Input/InputImageUpload";
  export default {
    name: "LandingPageEdit",
    components: {
      InputImageUpload,
      SelectColor,
      DatePicker,
      SaveButton,
      PreviewButton, DeleteButton, InputTextField, SelectOption, LineHr, TitleEdit},
    data(){
      return{
        button_color : false,
        font_color : false,
        background_color : false,
        optionCategory:[],
      }
    },
    computed: {
      ...mapState({
        form: state => {
          return state.LandingPage.form;
        }
      })
    },
    created() {
    },
    methods:{
      validateData(){
        if(!this.form.title){
          alert('Please input title');
          return false;
        }else if(!this.form.start_date || !this.form.end_date){
          alert('Please select date');
          return false;
        }else if(!this.form.cover_image_desktop){
          alert('Please select cover image desktop');
          return false;
        }
        else{
          return true;
        }
      },
      saveLandingPage(){
        if(this.validateData()){
          this.$store.dispatch("LandingPage/saveLandingPage",{
            id : this.form.id,
            data : this.form
          }).then(res=>{
            alert(res.response_msg);
            if(res.response_code == 200){
              this.goToLandingPage();
            }
          }).catch(()=>{
            alert("cannot save Landing page data");
          })
        }
      },
      showModalButtonColor(){
        this.button_color = true;
      },
      showModalFontColor(){
        this.font_color = true;
      },
      showModalBackgroundColor(){
        this.background_color = true;
      },
      goToLandingPage(){
        this.$router.push("/landing-page");
      },
      deleteLandingPage(){
        this.$store.dispatch("LandingPage/deleteLandingPage",this.form.id).then(res=>{
          alert(res.response_msg);
          if(res.response_code == 200){
            this.goToLandingPage();
          }
        }).catch(()=>{
          alert("cannot delete Landing page data");
        })
      },
      updateTitle(val){
        this.form.title = val;
      },
      updateStartDate(val){
        this.form.start_date = val;
      },
      updateEndDate(val){
        this.form.end_date = val;
      },
      updateButtonColor(val){
        this.form.button_color = val;
        this.button_color = false;
      },
      updateFontColor(val){
        this.form.font_color = val;
        this.font_color = false;
      },
      updateBackgroundColor(val){
        this.form.background_color = val;
        this.background_color = false;
      },
      updateBackgroundImage(val){
        this.form.background_image = val.imagePath;
        this.form.background_image_show = val.fullImagePath;
      },
      updateDesktopImage(val){
        this.form.cover_image_desktop = val.imagePath;
        this.form.cover_image_desktop_show = val.fullImagePath;
      },
      updateMobileImage(val){
        this.form.cover_image_mobile = val.imagePath;
        this.form.cover_image_mobile_show = val.fullImagePath;
      },
    }
  }
</script>

<style scoped>

</style>
